// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"57":"Server","386":"Clients","614":"Status"}[chunkId] || chunkId) + "." + {"57":"9a03bbaa","386":"ec19f568","567":"59d23ed9","614":"879502cc"}[chunkId] + ".css";
};